import { resetProxy } from '@paid-ui/utils/reset-proxy';

import { initialState } from '../initialState';
import { contractManager } from '../model';

export const resetContract = () => {
  resetProxy(contractManager, initialState);
};
